import { motion } from "framer-motion";
import { ArrowRight, Star } from "@phosphor-icons/react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/f356e486-2013-43a6-a960-a50c27505bc4/images/29383ace10214344ab9dbf2c4cf77c8c3d92666c7230385a3c21e76adff9e659.png";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-28 md:pt-36 pb-12 md:pb-20 px-5 md:px-10 lg:px-16 overflow-hidden grain"
    >
      <div className="grid grid-cols-12 gap-4 md:gap-6 items-end">
        {/* Left content */}
        <div className="col-span-12 lg:col-span-7 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="flex items-center gap-3 mb-6"
          >
            <span className="tick" />
            <span className="eyebrow">Issue 03 / Melbourne / Est. since '08</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.05 }}
            data-testid="hero-headline"
            className="font-display text-[14vw] sm:text-[12vw] lg:text-[8.5vw] xl:text-[8rem] leading-[0.86] tracking-tighter uppercase"
          >
            Master-
            <br />
            strokes
            <br />
            <span className="text-[#D85C3A] italic font-display">for</span> Melbourne.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.25 }}
            className="mt-8 max-w-xl text-lg md:text-xl text-[#222] leading-relaxed font-medium"
          >
            We paint heritage terraces, warehouse conversions, retail fit-outs and family
            homes — across all Melbourne metro suburbs. Fixed quotes. No mess. No surprises.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="mt-10 flex flex-wrap gap-4 items-center"
          >
            <a href="#book" data-testid="hero-cta-quote" className="btn-brut">
              Get a free quote <ArrowRight size={20} weight="bold" />
            </a>
            <a href="#estimator" data-testid="hero-cta-estimator" className="btn-outline-brut">
              Try AI estimator
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.55 }}
            className="mt-10 flex flex-wrap items-center gap-6"
          >
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} weight="fill" className="text-[#D85C3A]" />
              ))}
              <span className="ml-2 text-sm font-bold">4.9 · 80+ projects</span>
            </div>
            <span className="text-xs uppercase tracking-widest text-[#666]">
              Fully insured · Dulux accredited · Heritage-approved
            </span>
          </motion.div>
        </div>

        {/* Right hero image */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="col-span-12 lg:col-span-5 relative"
        >
          <div className="relative border-2 border-[#111] shadow-brut overflow-hidden aspect-[4/5] bg-[#1A1A1A]">
            <img
              src={HERO_IMG}
              alt="The Melbourne Painters — premium interior and exterior house painting across Melbourne"
              className="w-full h-full object-cover"
              loading="eager"
              fetchpriority="high"
              width="800"
              height="1000"
              decoding="async"
            />
            {/* Floating swatch tag */}
            <div className="absolute -bottom-4 -left-4 bg-[#F2F2EF] border-2 border-[#111] px-4 py-3 shadow-brut-sm">
              <div className="text-[10px] uppercase tracking-widest text-[#666]">Currently mixing</div>
              <div className="font-display text-lg">Burnt Terracotta · 24-A</div>
            </div>
            <div className="absolute top-4 right-4 bg-[#D85C3A] text-white border-2 border-[#111] px-3 py-2 text-xs font-bold uppercase tracking-widest">
              Now booking · Q1 2026
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
